export const SECTIONS = {
  itemDetails: 'itemDetails',
  lineDetails: 'lineDetails',
};
